import { openApi } from '@/api/request'

export default {
    indexPage (requestData) {
        const url = '/Rccl.OpenApi/Partner/Index'
        return openApi.post(url, requestData)
    },
    getUserPPP (sailData, shipCode) {
        const url = '/Rccl.OpenApi/Partner/GetUserPPP'
        return openApi.post(url, {
            sailData,
            shipCode,
        })
    },
    login (requestData) {
        const url = '/Rccl.OpenApi/Partner/Login'
        return openApi.post(url, requestData)
    },
    register (requestData) {
        const url = '/Rccl.OpenApi/Partner/Register'
        return openApi.post(url, requestData)
    },
    allowTui () {
        const url = '/Rccl.OpenApi/Partner/AllowTui'
        return openApi.post(url, {})
    },
    checkIsPartner (requestData) {
        const url = '/Rccl.OpenApi/Partner/CheckIsPartner'
        return openApi.post(url, requestData)
    },
    sendEmail (requestData) {
        const url = '/Rccl.OpenApi/Partner/ReactiveUser'
        return openApi.post(url, requestData)
    },
    isAllowTui (mobile) {
        const url = '/Rccl.OpenApi/Partner/IsAllowTui'
        return openApi.get(url, {
            params: {
                mobile,
                v: (new Date()).getTime()
            }
        })
    },
    isAllowTuiByToken (userName) {
        const url = '/Rccl.OpenApi/Partner/IsAllowTuiByToken'
        return openApi.get(url, {
            params: {
                userName,
                v: (new Date()).getTime()
            }
        })
    },
    goTui (requestData) {
        const url = '/Rccl.OpenApi/Partner/GoToTui'
        return openApi.get(url, {
            params: requestData,
            v: (new Date()).getTime()
        })
    },
    active (activeToken) {
        const url = '/Rccl.OpenApi/Partner/Active'
        return openApi.get(url, {
            params: {
                activeToken,
                v: (new Date()).getTime()
            }
        })
    }

}

